import { useEffect, useRef } from "react";

const useSendDisconnect = (store) => {
  const sentRef = useRef(false);

  useEffect(() => {
    if (!store?.dispatch) return;

    const sendDisconnect = () => {
      store.dispatch({
        type: "WEB_CHAT/SEND_EVENT",
        payload: {
          name: "handoff.status",
          value: {
            state: "userDisconnect",
          },
        },
      });
    };

    const sendOnce = () => {
      if (sentRef.current) return;
      sentRef.current = true;
      sendDisconnect();
    };

    const onPageHide = () => sendOnce();

    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") sendOnce();
    };

    window.addEventListener("pagehide", onPageHide);
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      window.removeEventListener("pagehide", onPageHide);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [store]);
};

export default useSendDisconnect;
